/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable jsdoc/require-returns */
/**
 *
 * @param titles
 */
export function setTitleComponent(titles: string = ''): string {
    let title = '';
    title = titles;
    return title.concat(' - Community4U');
}

/**
 *
 * @param path
 * @param index
 */
export function getSectionFromPath(path: string = '', index: number): string {
    const getArrayPath: string[] = path.split('/').reduce((segments: string[], segment: string) => {
        segment = segment.replace('-', ' ');
        segments.push(`${firstCharacterToUpperCase(segment)}`);
        return segments;
    }, []);
    getArrayPath.shift();
    return getArrayPath[index];
}

/**
 *
 * @param word
 */
export function firstCharacterToUpperCase(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

/**
 *
 * @param path
 */
export function transformPathtoTitle(path = '') {    
    let getArrayPath = [];
    let result;
    const community4U = 'Community4U';

    getArrayPath = path.split('/').reduce((segments: string[], segment: string) => {
        segment = segment.replace('-', ' ');
        segments.push(`${segment}`);
        return segments;
    }, []);
    getArrayPath.shift();
    let key: string;
    
    switch (getArrayPath.length){
    case 1:
        key = getArrayPath[0] as string;
        if ((titleLabels).has(key)) {
            key = titleLabels.get(key);
        } else {
            key = key.charAt(0).toUpperCase() + key.slice(1);
        }
        result = key + community4U;
        break;
    case 2:
        getArrayPath.join(' - ');
        key = getArrayPath[1] as string;
        key = key.charAt(0).toUpperCase() + key.slice(1);
        result = key + community4U;
        break;
    case 3: // pathname in my-solutions doesn't contain /news in the end
        getArrayPath.splice(2, 1);
        getArrayPath.join(' - ');
        key = getArrayPath[1] as string;
        if (titleLabels.has(key))
        {key = titleLabels.get(key); }
        result = key + ' - News' + community4U;
        break;
    case 4:
        getArrayPath.splice(2, 1);
        getArrayPath.join(' - ');
        key = getArrayPath[1] as string;
        if (titleLabels.has(key)) {
            key = titleLabels.get(key);
        } else {
            key = key.charAt(0).toUpperCase() + key.slice(1);
        };        
        getArrayPath[2] = (getArrayPath[2] as string).charAt(0).toUpperCase() + (getArrayPath[2] as string).slice(1);
        result = key + ' - ' + getArrayPath[2] + community4U;
        break;
    }
    return result as string;
}

export const titleLabels: Map<string, string> = new Map();
titleLabels.set('cams', 'CAMS');
titleLabels.set('decade financials', 'Decade Financials');
titleLabels.set('dream financials', 'Dream Financials');
titleLabels.set('erp', 'ERP');
titleLabels.set('erpx', 'ERPx');
titleLabels.set('financials', 'Financials');
titleLabels.set('consolidationcash', 'FPM');
titleLabels.set('fpa', 'FP&A');
titleLabels.set('hrm portal', 'HRM Portal');
titleLabels.set('ids', 'IDS');
titleLabels.set('kirp7', 'KIRP7');
titleLabels.set('map', 'MAP');
titleLabels.set('mik', 'MIK');
titleLabels.set('partner-forum', 'Partner Forum');
titleLabels.set('profiskal', 'Profiskal');
titleLabels.set('property-management', 'Property Management');
titleLabels.set('prosoft', 'Prosoft');
titleLabels.set('psa-suite', 'PSA Suite');
titleLabels.set('student management', 'Student Management');
titleLabels.set('te', 'T&E');
titleLabels.set('talent-management', 'Talent Management');
titleLabels.set('transfare', 'Transfare');    
titleLabels.set('csm', 'Support4U');  
titleLabels.set('university', 'University4U');
titleLabels.set('salespartners', 'Deal Management 4U');
titleLabels.set('resources', 'Resources4U');
titleLabels.set('my solutions', 'My Solutions');
titleLabels.set('news', 'News');
